import React from 'react';
import {Image} from 'react-native';

export default function Sunlight({ width, height } : SvgProps) {
  return <Image style={{ width, height }} source={require('./undraw_sunlight_re_0usx.svg')} />
};

